import { render, staticRenderFns } from "./viewTags.vue?vue&type=template&id=9f4f4e0a&scoped=true&"
import script from "./viewTags.vue?vue&type=script&lang=js&"
export * from "./viewTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4f4e0a",
  null
  
)

export default component.exports